import { createSlice } from '@reduxjs/toolkit';
import { getRegionListThunk } from './Region.thunk';

export const regionSlice = createSlice({
  name: 'region',
  initialState: {
    list: {
      items: [],
      pagination: {},
      loading: true,
    },
    globalSelected: undefined,
    searchSelected: undefined,
  },
  reducers: {
    setGlobalRegion: (state, action) => ({
      ...state,
      globalSelected: action.payload,
      searchSelected: undefined,
    }),
    setSearchRegion: (state, action) => {
      state.searchSelected = action.payload;
    },
    resetRegionListAction: (state, action) => ({
      ...state,
      list: {
        ...state.list,
        items: [],
        pagination: {},
      },
    }),
  },
  extraReducers: builder => {
    // Start Region list
    builder.addCase(getRegionListThunk.pending, (state, action) => {
      state.list = { ...state.list, loading: true };
    });
    builder.addCase(getRegionListThunk.fulfilled, (state, action) => {
      const { data } = action.payload;
      state.list = { ...state.list, items: data, loading: false };
    });
    builder.addCase(getRegionListThunk.rejected, (state, action) => {
      // state.list = { ...state.list, loading: false };
    });
    // End Region list
  },
});

export const getRegionList = (state: any) => state.region.list;
export const getGlobalRegionSelected = (state: any) =>
  state.region.globalSelected;

export const getSearchRegionSelected = (state: any) =>
  state.region.searchSelected;
export const { setGlobalRegion, setSearchRegion } = regionSlice.actions;

export default regionSlice.reducer;
